/* eslint-disable react/prop-types */
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { LinkedChainNavigation } from 'components/linkedChainNavigation/linkedChainNavigation'
import React, { FunctionComponent } from 'react'
import './styles.scss'
import { Link } from 'react-router-dom'

export interface IHorizontalNavigationProps {
  links: LinkedChainNavigation
  navigateBack: () => void
  unansweredQuestion?: string
}

export const HorizontalNavigation: FunctionComponent<
  IHorizontalNavigationProps
> = ({ children, links, navigateBack, unansweredQuestion }) => (
  <>
    {children}

    {unansweredQuestion && (
      <div className={`ui warning message`}>
        <div className={'header'}>
          Einige Fragen wurden noch nicht beantwortet
        </div>
        <p>
          Für eine korrekte Auswertung des Quizzes müssen alle Fragen
          beantwortet werden. Verwenden Sie den folgenden Link, um zur ersten
          unbeantworteten Frage zurückzukehren und sie zu beantworten. Sobald
          alle Fragen beantwortet sind, werden Ihnen automatisch die Resultate
          angezeigt.
        </p>
        <p>
          <Link to={unansweredQuestion}>
            <i className='undo icon' />
            Zu nicht beantworteten Fragen zurückkehren
          </Link>
        </p>
      </div>
    )}

    <div className='ui vertical very fitted clearing segment horizontal-navigation'>
      {links.previous && links.next !== undefined && (
        <button
          onClick={navigateBack}
          className={'ui basic secondary labeled icon button left floated'}
        >
          <i className='left chevron icon' /> Retour
        </button>
      )}
    </div>
  </>
)
